import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const Login = () => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setLoading] = useState(false)

    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();
    const test_link = "http://localhost:3000/login/"
    const production_link = "https://apple-tree-server.vercel.app/login/"

    const test_paid_link = "http://localhost:3000/paid/"
    const production_paid_link = "https://apple-tree-server.vercel.app/paid/"

    const checkPaid = async (company_reg) => {
        await axios.post(production_paid_link, {
            company_reg
        })
        .then((res) => {
            Cookies.set('token_status', res.data);
            console.log(res.data)
        } )
        .catch((err) => console.warn(err))
    }


    const handleSubmit = async (e) => {
            e.preventDefault()
            setError('')
            setLoading(true)
            axios.post(production_link,
            {
                email,
                password
            }
            )
            .then(async (response) => {
                console.log(response)
                Cookies.set('token_first_name', response.data.first_name, { expires: 3 })
                Cookies.set('token_last_name', response.data.last_name, { expires: 3 })
                Cookies.set('token_email', response.data.email, { expires: 3 })
                Cookies.set('token_company', response.data.company, { expires: 3 })
                Cookies.set('token_phone', response.data.phone, { expires: 3 })
                Cookies.set('token_id', response.data.id, { expires: 3 })
                Cookies.set('token_admin', response.data.admin, { expires: 3 })
                
                await checkPaid(response.data.company_reg)
                .then((res) => console.log('Payment checked successfully: ' + res))
                .catch((err) => console.warn("Payment couldnt be checked: " + err))
                setLoading(false)

                navigate('/')
                window.location.reload(false)
            })
            .catch(err => {
                console.log(err.response.data.error);
                setError(err.response.data.error);
                setPassword('')
                setLoading(false)
            })


        }



    return (
        <div className="reg-form d-flex justify-content-center align-items-center " onSubmit={handleSubmit}>
            <div className="w-75">
                <form className=" border p-4 rounded" onSubmit={(e) => {
                    handleSubmit(e)
                }}>
                    <h2 className="display-5 text-center text-muted">Sign In</h2>
            
                    <label for='email' className="form-label" >Email Address:</label>
                    <input type="email" name="email" className="form-control" onChange={(e) => {
                        setEmail(e.target.value)
                    }} value={email}/>
                    
                    <label for='email' className="form-label">Password:</label>
                    <div className="form-control d-flex justify-content-between" id='password-border'>
                        <input className="w-100 form-control border-0 shadow-none" type="password" id="password" name="password" style={{border: "none"}} onChange={(e) => {
                        setPassword(e.target.value)
                        }} value={password}/>
                    
                        {!showPassword && 
                            <button className="btn h-75" onClick={(e) => {
                                e.preventDefault();
                                setShowPassword(true);
                                document.getElementById('password').type = 'text';
                            }}>
                                <i class="bi bi-eye-slash" id="togglePassword"></i>
                            </button>     
                        }
                        {showPassword && 
                            <button className="btn h-75" onClick={(e) => {
                                e.preventDefault();
                                setShowPassword(false);
                                document.getElementById('password').type = 'password';
                            }}>
                                <i class="bi bi-eye"></i>
                            </button>     
                        }

                    </div>
                    
                    <p className="text-danger text-center">{error}</p>
                    <div className="mt-3 d-flex justify-content-center">
                        {!isLoading &&  <button type="submit" class='btn btn-primary'>Submit</button>}
                        {isLoading && 
                        <button class="btn btn-secondary" type="button" disabled>
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        Loading...
                        </button>
                        }
                    </div>
                </form>
            </div>
        </div> 
        
     );
}
 
export default Login;